<div class="out">
  <textarea #textA class="comment" name="name" [(ngModel)]="content" rows="6" cols="25"></textarea>
  <k-button class="cancel" icon="close.svg" background="transparent" kzLib (click)="cancel()"></k-button>

</div>
